import { type Plugin } from "@nuxt/types";

import { getSearchStore } from "@/store/search";
import SearchService from "@/utils/search";

declare module "vue/types/vue" {
  interface Vue {
    $search: SearchService;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $search: SearchService;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $search: SearchService;
  }
}

const plugin: Plugin = (context, inject) => {
  const searchStore = getSearchStore(context.store);
  searchStore.fetchSearchHistory();

  const search = new SearchService(context);

  inject("search", search);
  context.$search = search;
};

export default plugin;
